import '@fontsource-variable/roboto-serif';
import '@fontsource-variable/roboto';
import './styles/index.pcss';
import './setupSentry';

import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import Tooltip from '@ryangjchandler/alpine-tooltip';
import { roundArrow } from 'tippy.js';
import 'tippy.js/dist/svg-arrow.css';

import {
	bookmarkToggle,
	counter,
	courseTopic,
	otherToggle,
	passwordInput,
	paymentForm,
	quiz,
	registrationForm,
	scorm,
	shareModal,
} from './modules';

import.meta.glob('./assets/**/*', { eager: true, import: 'default' });

Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.plugin(
	Tooltip.defaultProps({
		theme: 'secondary',
		arrow: roundArrow,
	}),
);

// Register data modules
Alpine.data('bookmarkToggle', bookmarkToggle);
Alpine.data('counter', counter);
Alpine.data('courseTopic', courseTopic);
Alpine.data('otherToggle', otherToggle);
Alpine.data('passwordInput', passwordInput);
Alpine.data('paymentForm', paymentForm);
Alpine.data('quiz', quiz);
Alpine.data('registrationForm', registrationForm);
Alpine.data('scorm', scorm);
Alpine.data('shareModal', shareModal);

// This is required for AlpineJS dev tools browser extension; can be removed in production
window.Alpine = Alpine;

Alpine.start();
